// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"eb8362cf","748":"f86251f4"}[chunkId] + ".chunk.css";
};